import {
  ContentState,
  DraftInlineStyle,
  EditorState,
  convertFromHTML,
  convertFromRaw
} from 'draft-js'
import { FormatValues } from './types'
import { TextTypes } from '../types'

//converts legacy text box values or rich-text JSON to a Draft.js rich editor state
export const convertStandardTextBoxToRichEditorState = (args: {
  title: string
  textType: TextTypes
  currentRichText: string
}): EditorState => {
  const { title, textType, currentRichText } = args
  // if rich text exists, return it in EditorState format
  if (currentRichText.length) return convertJSONtoEditorState(currentRichText)

  // if text box is new, return an empty EditorState
  if (!title.length) return EditorState.createEmpty()

  // otherwise convert the existing text & sizing into an EditorState
  let htmlString = ''
  switch (textType) {
    case TextTypes.BODY:
      htmlString = `<div>${title}</div>`
      break
    case TextTypes.SUBHEADER:
      htmlString = `<h3>${title}</h3>`
      break
    case TextTypes.HEADER:
      htmlString = `<h2>${title}</h2>`
      break
    default:
      break
  }
  const blocksFromHTML = convertFromHTML(htmlString)
  const contentState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  )
  const editorState = EditorState.createWithContent(contentState)
  return editorState
}

export const convertJSONtoEditorState = (richTextJSONString: string): EditorState => {
  const parsedState = JSON.parse(richTextJSONString)
  const contentState = convertFromRaw(parsedState)
  const editorState = EditorState.createWithContent(contentState)
  return editorState
}

// Parses the styles of the current highlighted/cursor text
// to determine what ToggleButtons to make active
export const getSelectedFormats = (currInlineStyle: DraftInlineStyle): FormatValues[] => {
  const selectedFormats: FormatValues[] = []
  for (const style in FormatValues) {
    if (currInlineStyle.has(style)) selectedFormats.push(style as FormatValues)
  }
  return selectedFormats
}
